import { Seo } from "@/components/Seo";
import { Hero } from "@/sections/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/sections/Services";
import { ImageBand } from "@/sections/ImageBand";
import { Normativa } from "@/sections/Normativa";
import { About } from "@/sections/About";
import { FaqSection } from "@/sections/FaqSection";
import { BlogPreview } from "@/sections/BlogPreview";
import { Contact } from "@/sections/Contact";
import {
  businessJsonLd,
  physiciansJsonLd,
  websiteJsonLd,
  webPageJsonLd,
  faqJsonLd,
} from "@/data/site";

const TITLE = "BPMedLav — Medico Competente a Roma | Sorveglianza Sanitaria D.Lgs 81/08";
const DESCRIPTION =
  "Studio di Medicina del Lavoro a Roma. Medici competenti per sorveglianza sanitaria, visite in azienda, formazione primo soccorso e consulenza ai sensi del D.Lgs 81/08. Dr. Buomprisco e Dr. Perri.";

export default function Home() {
  return (
    <>
      <Seo
        title={TITLE}
        description={DESCRIPTION}
        path="/"
        jsonLd={[
          businessJsonLd(),
          websiteJsonLd(),
          ...physiciansJsonLd(),
          webPageJsonLd({ path: "/", title: TITLE, description: DESCRIPTION }),
          faqJsonLd(),
        ]}
      />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <ImageBand />
        <Normativa />
        <About />
        <FaqSection />
        <BlogPreview />
        <Contact />
      </main>
    </>
  );
}
